import { render, staticRenderFns } from "./AnnouncementIndex.vue?vue&type=template&id=1b095e8e&"
import script from "./AnnouncementIndex.vue?vue&type=script&lang=js&"
export * from "./AnnouncementIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports